import { getImagePath } from '.';

const amexIMG = getImagePath('amex.png');
const discoverIMG = getImagePath('discover.png');
const mastercardIMG = getImagePath('mastercard.png');
const dinersIMG = getImagePath('dci.png');
const visaIMG = getImagePath('visa.png');

const bankConfig = {
  americanexpress: '34',
  dinersclub: '38',
  discover: '60',
  mastercard: '52',
  visa: '41'
};

export const mapBankToFirstCardTwoDigits = (bank = '') => bankConfig[bank.toLowerCase()];

export const mapCardTypeToIMG = (slug) => {
  switch (slug.toLowerCase()) {
    case 'visa':
      return visaIMG;
    case 'mastercard':
      return mastercardIMG;
    case 'discover':
      return discoverIMG;
    case 'dinersclub':
      return dinersIMG;
    case 'americanexpress':
      return amexIMG;
    default:
      throw new Error(`Payment method slug: ${slug} not supported`);
  }
}

export const sortSubscriptionsByDate = (subscriptions) => {
  return subscriptions.sort((a, b) => new Date(a.subscriptionState?.createdAt).getTime() - new Date(b.subscriptionState?.createdAt).getTime());
};
